import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import ReactPlaceholder from 'react-placeholder';
import {
  InputPlaceholder,
  TextareaPlaceholder,
  Grid,
  FlexRow,
  FlexBaseCol
} from '@contently/toolkit';

import HeadlineTextEditor from './HeadlineTextEditor';
import BodyTextEditor from './BodyTextEditor';

function StoryPlaceholder() {
  return (
    <React.Fragment>
      <ReactPlaceholder customPlaceholder={<InputPlaceholder withLabel />} />
      <ReactPlaceholder customPlaceholder={<TextareaPlaceholder withLabel />} />
    </React.Fragment>
  );
}

export default function StoryContent({ storyId, historyMode, readOnlyMode }) {
  return (
    <Suspense fallback={<StoryPlaceholder />}>
      <Grid>
        <FlexRow margin="medium">
          <FlexBaseCol>
            <HeadlineTextEditor
              storyId={storyId}
              historyMode={historyMode}
              readOnlyMode={readOnlyMode}
            />
          </FlexBaseCol>
        </FlexRow>
        <FlexRow margin="medium">
          <FlexBaseCol>
            <BodyTextEditor
              storyId={storyId}
              historyMode={historyMode}
              readOnlyMode={readOnlyMode}
            />
          </FlexBaseCol>
        </FlexRow>
      </Grid>
    </Suspense>
  );
}

StoryContent.defaultProps = {
  historyMode: false,
  readOnlyMode: false
};

StoryContent.propTypes = {
  storyId: PropTypes.number.isRequired,
  historyMode: PropTypes.bool,
  readOnlyMode: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/javascript/client/components/textEditor/StoryContent.jsx